import { z } from 'zod/v4'

export const FieldSectionHandleSchema = z
  .string()
  .min(1)
  .regex(
    /^[a-zA-Z0-9_-]+$/,
    'Handle can only contain letters, numbers, underscores, and hyphens',
  )

export const GetFieldSectionSchema = z.object({
  id: z.string(),
  handle: FieldSectionHandleSchema,
  name: z.string().min(1),
})

export type GetFieldSection = z.infer<typeof GetFieldSectionSchema>

export const UpdateFieldSectionSchema = z.object({
  id: z.string(),
  name: z.string().min(1),
})

export type UpdateFieldSectionInput = z.infer<typeof UpdateFieldSectionSchema>

export const ListFieldSectionsSchema = z.object({
  workplaceId: z.string(),
})
